import { styled } from '@mui/material';

import { FreePlan } from './components/FreePlan';
import { StarterPlan } from './components/StarterPlan';
import { ProPlan } from './components/ProPlan';
import { EnterprisePlan } from './components/EnterprisePlan';
import { usePaymentPlansContext } from '../../context/usePaymentPlansContext';
import { EnterpriseInfo } from './components/EnterpriseInfo';

const StyledPlanOptions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  alignItems: 'stretch',
}));

export const PlanOptions = () => {
  const { tier } = usePaymentPlansContext();

  if (tier === 'ENTERPRISE') {
    return <EnterpriseInfo />;
  }

  return (
    <StyledPlanOptions>
      <FreePlan />
      <StarterPlan />
      <ProPlan />
      <EnterprisePlan />
    </StyledPlanOptions>
  );
};
